import { QueryKeys } from "@app/constants/query-keys.ts";
import { useApis } from "@app/data/apis.ts";
import { CityStatePostModel } from "@app/data/engine.ts";
import { handleApiError } from "@app/helpers/error-helper.tsx";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useQuery } from "bi-lib";
import { toast } from "react-toastify";

interface Props {
    id?: number;
}

export default function useSetupCityStateData({ id }: Props = {}) {
    const apis = useApis();
    const queryClient = useQueryClient();

    const getSortedCityStateQuery = useQuery({
        queryKey: [QueryKeys.GetSortedCityState],
        queryFn: () => apis.engine.setupApi.setupApiGetSortedCityStateList(),
    });

    const getCityStateQuery = useQuery({
        queryKey: [QueryKeys.GetCityState, { id }],
        queryFn: () => apis.engine.setupApi.setupApiGetCityStateList({ id }),
        enabled: id != undefined,
    });

    const saveCityStateMutation = useMutation({
        mutationFn: (post: CityStatePostModel) => apis.engine.setupApi.setupApiSaveCityStateCreate(post),
        onSuccess: (_, { cityStateId }) => {
            void queryClient.invalidateQueries({ queryKey: [QueryKeys.GetSortedCityState] });
            void queryClient.invalidateQueries({
                queryKey: [QueryKeys.GetCityState, { id: cityStateId }],
            });
            toast.success("Work location saved");
        },
        onError: (error: Error) => handleApiError(error, "Failed to save work location"),
    });

    return {
        cityStates: getSortedCityStateQuery,
        cityState: getCityStateQuery,

        saveCityState: saveCityStateMutation,
    };
}
